import { MessageState } from '../../../model/MessageState';

export class MessageSearchRequest {

    _page; // number
    _term; // string
    _state; // number
    _companyId; // number

    constructor(companyId = undefined) {
        this._page = 1;
        this._term = '';
        this._state = MessageState.ALL;
        this._companyId = companyId;
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setState(state) {
        this._state = state;
    }

    body() {
        return {
            criteria: {
                page: this._page,
                term: this._term,
                limit: 10,
                active: this._isActive(),
                machine_id: undefined,
                worker_id: undefined,
                company_id: this._companyId,
                construction_id: undefined,
                document_id: undefined,
            },
        };
    }

    _isActive() {
        switch ( this._state ) {
            case MessageState.ACTIVE:
                return true;
            case MessageState.INACTIVE:
                return false;
            default:
                return undefined;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/message/list/message-search/MessageSearchRequest.js